import { DataConnection, DataGlueGraph, FunctionDefinition, NodeInstance } from '@glueapp/graph-types';

const cleanNodeInstanceConnections = (connections: DataConnection[], nodeInstances: NodeInstance[]): DataConnection[] => {
    const nodeMap = new Map(nodeInstances.map(node => [node.id, node]));

    return connections.filter(connection => {
        // Check if source node exists
        const sourceNode = nodeMap.get(connection.sendingNodeInstanceId);
        if (!sourceNode) {
            return false;
        }

        // Check if target node exists
        const targetNode = nodeMap.get(connection.receivingNodeInstanceId);
        if (!targetNode) {
            return false;
        }

        // Check if source port exists
        if (connection.sendingPortType === 'inherent') {
            // For inherent connections, check for standard inherent port
            if (connection.sendingPortName !== 'InherentOut') {
                return false;
            }
        } else {
            // For external connections, check regular out ports
            if (!sourceNode.outPorts.some(port => port.name === connection.sendingPortName)) {
                return false;
            }
        }

        // Check if target port exists
        if (connection.receivingPortType === 'inherent') {
            // For inherent connections, check for standard inherent port
            if (connection.receivingPortName !== 'InherentIn') {
                return false;
            }
        } else {
            // For external connections, check regular in ports
            if (!targetNode.inPorts.some(port => port.name === connection.receivingPortName)) {
                return false;
            }
        }

        return true;
    });
};

const cleanFunctionConnections = (functionDef: FunctionDefinition): FunctionDefinition => {
    const cleanedConnections = cleanNodeInstanceConnections(functionDef.connections, functionDef.nodeInstances);

    return {
        ...functionDef,
        connections: cleanedConnections,
    };
};

export const cleanupInvalidConnections = (graph: DataGlueGraph): DataGlueGraph => {
    // Clean root-level connections
    const cleanedConnections = cleanNodeInstanceConnections(graph.connections, graph.nodeInstances);

    // Clean connections in functions
    const cleanedFunctions = graph.functions.map(functionDef => cleanFunctionConnections(functionDef));

    return {
        ...graph,
        connections: cleanedConnections,
        functions: cleanedFunctions,
    };
};
